/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：707
 */

module.exports = {
  container: "RichTextEditor_container__1Kjot",
  editor: "RichTextEditor_editor__3YZc4",
  footer: "RichTextEditor_footer__YU2WE",
  content: "RichTextEditor_content__2U42C",
  paletteTrigger: "RichTextEditor_paletteTrigger__2UNSe"
}
